<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
<!--      <div>-->
<!--        <button-add @click="toAddPage" />-->
<!--      </div>-->
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <input-select selectTitle="业务系统" :selectKey="'parentCode'" selectWidth="120px" :selectData="typeList" @search="searchSelect" style="margin-right: 10px"/>
        <input-select selectTitle="是否启用" :selectKey="'ifEnable'" selectWidth="120px" :selectData="enableList" @search="searchSelect" style="margin-right: 10px"/>
      </div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @goToMessageConfig="goToModifyPage" @resetRow="resetRow" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @changeSwitch="changeSwitch" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/common/buttons/button-add'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Message'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import InputSelect from '../../../components/Input/InputSelect'

  export default {
    components: {
      InputSelect,
      TableMain,
      InputSearch,
      ButtonAdd,
      Breadcrumb},
    name: 'config-management',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧消息',
          name: 'message-template-manage'
        }, {
          value: '消息推送配置'
        }],
        searchPlaceholder: '消息类型/消息模板',
        searchKey: '',
        deleteTipInfo: '是否确认删除该账号？',
        tableHead: [{
          prop: 'parentName',
          label: '业务系统'
        }, {
          prop: 'eventName',
          label: '消息类型'
        }, {
          prop: 'templateTitle',
          label: '消息模板名称'
        }, {
          prop: 'parkReceiver',
          label: '园区方接收人'
        }, {
          prop: 'enterpriseReceiver',
          label: '住户接收人'
        }, {
          prop: 'ifEnable',
          label: '是否启用',
          active: '是',
          inactive: '否',
          isSwitch: true
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        operationArr: ['messageConfig', 'reset'],

        parentCode: '',
        ifEnable: '',
        typeList: [],
        enableList: [
          {key: '', label: '全部'},
          {key: '0', label: '未启用'},
          {key: '1', label: '已启用'}
        ]
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getWxEventConfigTree()
      this.getPage()
    },
    activated() {
      this.getWxEventConfigTree()
      this.getPage()
    },
    methods: {
      toAddPage () {
        this.$router.push({
          name: 'message-push-add'
        })
      },
      // 查询类型
      getWxEventConfigTree () {
        this.$axios.get(api.getWxEventConfigTree, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.map(v => {
                v.key = v.code
                v.label = v.name
              })
              this.typeList = data
              this.typeList.unshift({key: '', label: '全部'})
            }
          })
          .catch(errorHandler('获取类型失败'))
      },
      getPage () {
        this.$axios.post(api.getWxPushConfigPage, {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          searchKey: this.searchKey,
          ifEnable: this.ifEnable,
          parentCode: this.parentCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.code = v.eventCode
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      searchSelect (v) {
        this.pageNum = 1
        this[v.key] = v.value
        this.getPage()
      },
      search (v) {
        this.pageNum = 1
        this.searchKey = v
        this.getPage()
      },

      changeSwitch (data) {
        this.$confirm('是否确认修改启用状态？', '提示')
          .then(() => {
            for (let i in data) {
              if (data[i] === '--') {
                data[i] = ''
              }
            }
            if (data.detailMap === '') {
              data.detailMap = null
            }
            this.$axios.post(api.saveOrUpdateWxPushConfig, data)
              .then(res => {
                nSuccess('修改成功')
                this.getPage()
              })
              .catch(errorHandler('修改失败'))
          })
          .catch(() => {
            this.getPage()
          })
      },
      // 修改
      goToModifyPage (code) {
        this.$router.push({
          path: `/message_push_modify/${code}`
        })
      },

      // 重置
      resetRow (code) {
        this.$confirm('是否确认重置此消息配置？', '提示')
          .then(() => {
            this.$axios.post(api.resetWxPushConfig, {
              eventCode: code
            })
              .then(res => {
                nSuccess('重置成功')
                this.getPage()
              })
              .catch(errorHandler('重置失败'))
          })
          .catch(() => {})
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/MessageService/MessagePushConfig/MessagePushConfig.vue